import sliceCreator from '../../index.jsx';
import {UPDATE_DEALER} from '../../../constants/index.jsx';
const _updateDealerAction = sliceCreator('UPDATE_DEALER', UPDATE_DEALER, 'put');

const { asyncAction: updateDealerAction, reducer, clearData: clearUpdateDealerAction } = _updateDealerAction;

export default reducer;

export {
    updateDealerAction,
    clearUpdateDealerAction
}